import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Combustiveis} from '../model/RetornoGetCombustiveis';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-modal-ajuste-preco-negociado',
  templateUrl: './modal-ajuste-preco-negociado.component.html',
  styleUrls: ['./modal-ajuste-preco-negociado.component.scss'],
})
export class ModalAjustePrecoNegociadoComponent implements OnInit {
  @Output() salvarModificacoes = new EventEmitter<boolean>();
  @Output() salvarCombustivel = new EventEmitter<Combustiveis>();
  @Input() combustivel: Combustiveis | null = null;

  public precoNegociadoForm = new FormGroup({
    dataInicio: new FormControl(''),
    datCadastro: new FormControl(''),
    dscStatusAcordo: new FormControl(''),
    descricaoCombustivel: new FormControl(''),
    precoBomba: new FormControl(0),
    precoNegociado: new FormControl(0),

    tipoDesconto: new FormControl('descontoReais'),
    descontoEmReais: new FormControl(0),
    descontoEmPorcentagem: new FormControl(0),

    tituloBomba: new FormControl('Preço na bomba'),
    tituloDesconto: new FormControl('Desconto em R$'),
    tituloNegociado: new FormControl('Uve / SPS'),

    descricaoBomba: new FormControl('Preço na bomba'),
    descricaoDesconto: new FormControl('Desconto em R$'),
    descricaoNegociado: new FormControl('Uve / SPS'),
  });

  ngOnInit(): void {

    var desc = 0;
    var descPorcentagem = 0;

    if (this.combustivel?.combustivel.precos.precoNegociado[0].preco && this.combustivel?.combustivel.precos.precoUnitario[0].preco) {

      desc = Math.round((this.combustivel?.combustivel.precos.precoUnitario[0].preco - this.combustivel?.combustivel.precos.precoNegociado[0].preco) * 100) / 100;

      descPorcentagem = Math.round((100 - (((this.combustivel?.combustivel.precos.precoUnitario[0].preco - desc) / this.combustivel?.combustivel.precos.precoUnitario[0].preco) * 100)) * 100) / 100;
    }
    this.precoNegociadoForm.patchValue({
      dataInicio: this.combustivel?.combustivel.datInicio,
      datCadastro: this.combustivel?.combustivel.datCadastro,
      dscStatusAcordo: this.combustivel?.combustivel.dscStatusAcordo,
      descricaoCombustivel: this.combustivel?.descricaoCombustivel,
      precoBomba: this.combustivel?.combustivel.precos.precoUnitario[0].preco,
      descontoEmReais: desc,
      descontoEmPorcentagem: descPorcentagem,
      precoNegociado: this.combustivel?.combustivel.precos.precoNegociado[0].preco,

      tituloBomba: this.combustivel?.combustivel.precos.precoUnitario[0].titulo,
      tituloDesconto: this.combustivel?.combustivel.precos.precoUnitario[0].titulo,
      tituloNegociado: this.combustivel?.combustivel.precos.precoNegociado[0].titulo,

      descricaoBomba: this.combustivel?.combustivel.precos.precoUnitario[0].descricao,
      descricaoDesconto: this.combustivel?.combustivel.precos.precoUnitario[0].descricao,
      descricaoNegociado: this.combustivel?.combustivel.precos.precoNegociado[0].descricao,
    });
  }

  updateValor(event: any, campo: string) {
    event.preventDefault();

    const valor = event.target.value;
    const precoBomba = this.precoNegociadoForm.controls['precoBomba'].value || 0;
    const desconto =
      this.precoNegociadoForm.controls['descontoEmReais'].value || 0;


    switch (campo) {
      case 'descEmReais':
        if (precoBomba > valor) {
          const novoValor = Math.round((precoBomba - desconto) * 100) / 100;
          var valorPercentual = Math.round((100 - (((precoBomba - valor) / precoBomba) * 100)) * 100) / 100;

          this.precoNegociadoForm.patchValue({precoNegociado: novoValor, descontoEmPorcentagem: valorPercentual});
        } else {
          this.precoNegociadoForm.patchValue({descontoEmReais: 0, descontoEmPorcentagem: 0});
        }

        break;

      case 'descEmPercentagem':
        if (valor <= 100) {
          const novoValor = Math.round((precoBomba - (precoBomba * valor / 100)) * 100) / 100;
          var valorReais = Math.round((precoBomba - novoValor) * 100) / 100;
          this.precoNegociadoForm.patchValue({precoNegociado: novoValor, descontoEmReais: valorReais});
        } else {
          this.precoNegociadoForm.patchValue({descontoEmPorcentagem: 0, descontoEmReais: 0});
        }
        break

      case 'precoNegociado':
        if (precoBomba > valor) {
          const novoDesconto = Math.round((precoBomba - valor) * 100) / 100;
          var descPorcentagem = Math.round(((((precoBomba - valor) / precoBomba) * 100)) * 100) / 100;
          this.precoNegociadoForm.patchValue({descontoEmReais: novoDesconto, descontoEmPorcentagem: descPorcentagem});

        } else {
          this.precoNegociadoForm.patchValue({
            precoNegociado: precoBomba,
            descontoEmReais: 0,
            descontoEmPorcentagem: 0
          });
        }
        break;
    }
  }

  salvarModificacoesCombustivel(valor: boolean): void {

    if (this.combustivel) {

      this.combustivel.combustivel.precos.precoNegociado[0].preco = this.precoNegociadoForm.get('precoNegociado')?.value || 0;

      this.combustivel.combustivel.precos.descontoEmReais = this.precoNegociadoForm.get('descontoEmReais')?.value || 0;

      this.combustivel.combustivel.precos.descontoEmPorcentagem = this.precoNegociadoForm.get('descontoEmPorcentagem')?.value || 0;
      console.log(this.combustivel.combustivel.precos);
    }

    this.salvarModificacoes.emit(valor);
  }


}
